// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6143":"0e7e4f04","6288":"67b5170b"}[chunkId] + ".chunk.css";
};